import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, withStyles, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, Chip, TextField, IconButton } from '@material-ui/core';
import { FaArrowLeft, FaArrowRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { translateText } from '../../utils/translate';
import cidadesData from '../Utils/cidades.json';
import { isVisitorCookiesAllowed } from '../Utils/CookieConsent';
import HeaderMenu from '../Utils/Header';
import Footer from '../Utils/Footer';
import RouteTracker from '../Utils/RouteTracker';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 0,
    backgroundColor: '#fff',
    color: '#333',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', // Top right
    alignItems: 'flex-start',
    marginBottom: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing.unit * 1,
    },
  },
  filters: {
    display: 'flex',
    justifyContent: 'flex-end', // Top right
    alignItems: 'center',
    gap: theme.spacing.unit * 2.5,
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing.unit * 1.5,
    },
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center content horizontally (including checkboxes)
    marginRight: theme.spacing.unit * 1.5,
    marginBottom: 0, // Remove extra bottom margin for alignment
    minWidth: 140,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      minWidth: '100%',
    },
  },
  // Add a new style for the checkbox group
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0,
    minHeight: 56,
    marginTop: 20, // Add top margin to align with dropdowns
  },
  checkboxRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  grid: {
    marginTop: theme.spacing.unit * 2,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(480px, 1fr))',
    gap: theme.spacing.unit * 3,
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(2, minmax(420px, 1fr))',
      gap: theme.spacing.unit * 2.5,
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 2,
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 1.5,
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit,
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 0.5,
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0,
    minHeight: 260,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.spacing.unit,
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#333',
    marginBottom: '10px',
    marginRight: '10px',
  },
  media: {
    width: '58%',
    minWidth: 220,
    height: '100%',
    objectFit: 'cover',
  },
  content: {
    flex: '1 0 auto',
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '42%',
    minWidth: 180,
  },
  userInfo: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  userPhoto: {
    width: 100,
    height: 100,
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: theme.spacing.unit,
  },
  noData: {
    textAlign: 'center',
    color: '#999',
    marginTop: theme.spacing.unit * 4,
  },
  dialogContent: {
    padding: theme.spacing.unit * 2,
  },
  dialogTitle: {
    padding: theme.spacing.unit * 2,
  },
  imageList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  imageItem: {
    cursor: 'pointer',
    width: 100,
    height: 100,
    objectFit: 'cover',
  },
  selectedImage: {
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing.unit * 2,
  },
  banner: {
    position: 'absolute',
    top: '70px', // Move the banner down
    left: '0px', // Move the banner to the left
    width: '90px',
    height: '25px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '30px',
    transform: 'rotate(-45deg)', // Flip the rotation for left side
    transformOrigin: 'top left', // Anchor to top left
    zIndex: 2,
  },
  premiumBanner: {
    backgroundColor: '#0000FF', // Blue color for Premium
  },
  opportunityBanner: {
    backgroundColor: '#FF0000', // Red color for Opportunity
    top: '90px', // Align with the premium banner
    left: '20px', // Adjust position to be side by side on the left
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 2,
    gap: theme.spacing.unit * 2,
    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing.unit * 1.5,
    },
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing.unit,
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing.unit * 0.8,
    },
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing.unit * 0.5,
    },
  },
});

const translations = {
  en: {
    listTitle: "List of Properties",
    loading: "Loading properties...",
    noData: "No properties available at the moment.",
    detailsTitle: "Property Details",
    category: "Category",
    location: "Location",
    price: "Price",
    area: "Area",
    rooms: "Number of Rooms",
    bathrooms: "Number of Bathrooms",
    garageSlots: "Garage",
    energyCategory: "Energy Category",
    description: "Description",
    images: "Images",
    agentInfo: "Agent Information",
    name: "Name",
    email: "Email",
    contact: "Contact",
    close: "Close",
    district: "District",
    premium: "Premium",
    opportunity: "Opportunity",
    keywords: "Keywords",
    all: "All",
    noImages: "No images available.",
    categories: [
      "Apartments",
      "Rooms",
      "Houses",
      "Lands",
      "Farms and Estates",
      "Garages",
      "Buildings",
      "Offices",
      "Warehouses",
      "Stores",
    ],
    garageOptions: ["Box", "Place", "None"],
    business_type: "Business Type",
    buy: "Buy",
    rent: "Rent",
  },
  pt: {
    listTitle: "Lista de Imóveis",
    loading: "Carregando imóveis...",
    noData: "Não existem imóveis disponíveis no momento.",
    detailsTitle: "Detalhes do Imóvel",
    category: "Categoria",
    location: "Localização",
    price: "Preço",
    area: "Área",
    rooms: "Número de Quartos",
    bathrooms: "Numero de casas de banho",
    garageSlots: "Garagem",
    energyCategory: "Categoria Energética",
    description: "Descrição",
    images: "Imagens",
    agentInfo: "Informações do Agente",
    name: "Nome",
    email: "Email",
    contact: "Contato",
    close: "Fechar",
    district: "Distrito",
    premium: "Premium",
    opportunity: "Oportunidade",
    keywords: "Palavras-chave",
    all: "Todos",
    noImages: "Não há imagens disponíveis.",
    categories: [
      "Apartamentos",
      "Quartos",
      "Moradias",
      "Terrenos",
      "Quintas e Herdades",
      "Garagens",
      "Prédios",
      "Escritórios",
      "Armazéns",
      "Lojas",
    ],
    garageOptions: ["Box", "Lugar", "Sem"],
    business_type: "Tipo de Negócio",
    buy: "Comprar",
    rent: "Arrendar",
  },
  fr: {
    listTitle: "Liste des Propriétés",
    loading: "Chargement des propriétés...",
    noData: "Aucune propriété disponible pour le moment.",
    detailsTitle: "Détails de la Propriété",
    category: "Catégorie",
    location: "Emplacement",
    price: "Prix",
    area: "Superficie",
    rooms: "Nombre de Chambres",
    bathrooms: "Nombre de Salles de Bain",
    garageSlots: "Garage",
    energyCategory: "Catégorie Énergétique",
    description: "Description",
    images: "Images",
    agentInfo: "Informations sur l'Agent",
    name: "Nom",
    email: "Email",
    contact: "Contact",
    close: "Fermer",
    district: "District",
    premium: "Premium",
    opportunity: "Opportunité",
    keywords: "Mots-clés",
    all: "Tous",
    noImages: "Aucune image disponible.",
    categories: [
      "Appartements",
      "Chambres",
      "Maisons",
      "Terrains",
      "Fermes et Domaines",
      "Garages",
      "Bâtiments",
      "Bureaux",
      "Entrepôts",
      "Magasins",
    ],
    garageOptions: ["Box", "Place", "Aucun"],
    business_type: "Type de Commerce",
    buy: "Acheter",
    rent: "Louer",
  },
};

// Use keys for districts, values for cities
const districts = Object.keys(cidadesData);

const ImoveisPage = ({ classes }) => {
  const [imoveis, setImoveis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImovel, setSelectedImovel] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [filters, setFilters] = useState({
    district: '',
    city: '', // <-- Add city filter
    category: '', // will store index or ''
    premium: false,
    opportunity: false,
    keywords: '',
    business_type: '',
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");
  const [district, setDistrict] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);

  const location = useLocation();
  const t = translations[language];
  const getApiUrl = () => {
    return "/api"; // Standardized API base path
  };

  const API_URL = getApiUrl(); // Use standardized API URL

  // Update cities when district filter changes (instant update)
  useEffect(() => {
    if (district) {
      setCities(cidadesData[district] || []);
    } else {
      setCities([]);
    }
    setCity('');
  }, [district]);

  useEffect(() => {
    const redirectFromSearch = localStorage.getItem('redirectFromSearch') === 'true';
    if (location.state && redirectFromSearch) {
      let catIdx = '';
      if (location.state.category || location.state.categories) {
        const catVal = location.state.category || location.state.categories;
        for (const lang of Object.keys(translations)) {
          const idx = translations[lang].categories.indexOf(catVal);
          if (idx !== -1) {
            catIdx = idx;
            break;
          }
        }
      }
      // Use citiesArray if present, otherwise fallback to district lookup
      let nextCities = [];
      if (location.state.citiesArray && Array.isArray(location.state.citiesArray)) {
        nextCities = location.state.citiesArray;
      } else if (location.state.district) {
        nextCities = cidadesData[location.state.district] || [];
      }
      setCities(nextCities);
      setFilters({
        district: location.state.district || '',
        city: location.state.city || '',
        category: catIdx,
        keywords: location.state.searchText || '',
        business_type: location.state.business_type || '',
        premium: false,
        opportunity: false,
      });
      setDistrict(location.state.district || '');
      // Set city after cities array is set, to ensure dropdown is populated
      setTimeout(() => {
        setCity(location.state.city || '');
      }, 0);
      localStorage.removeItem('redirectFromSearch');
    } else {
      setFilters({
        district: '',
        city: '',
        category: '',
        premium: false,
        opportunity: false,
        keywords: '',
        business_type: '',
      });
      setDistrict('');
      setCity('');
      setCities([]);
    }
    fetchImoveis();
  }, [location.state]);

  useEffect(() => {
    const handleLanguageChange = () => {
      const lang = localStorage.getItem("language") || "pt";
      setLanguage(lang);
      // Only persist language if cookies are allowed
      if (isVisitorCookiesAllowed()) {
        localStorage.setItem("language", lang);
      }
    };
    window.addEventListener("languageChange", handleLanguageChange);
    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  useEffect(() => {
    if (isVisitorCookiesAllowed()) {
      localStorage.setItem('imoveisFilters', JSON.stringify(filters));
    }
  }, [filters]);

  // Clear filters on unmount (leaving the page)
  useEffect(() => {
    return () => {
      setFilters({
        district: '',
        city: '',
        category: '',
        premium: false,
        opportunity: false,
        keywords: '',
        business_type: '',
      });
      setDistrict('');
      setCity('');
      setCities([]);
    };
  }, []);

  const fetchImoveis = async () => {
    try {    
      // Use only active endpoint for customer view
      const response = await axios.get(`${API_URL}/imoveis`, {
        withCredentials: true,
      });
      const translatedImoveis = await Promise.all(response.data.map(async (imovel) => {
        if (language !== "pt") {
          const translatedTitle = await translateText(imovel.title, language);
          return { ...imovel, title: translatedTitle };
        }
        return imovel;
      }));
      setImoveis(translatedImoveis);
      setIsLoading(false);
    } catch (error) {
      setError('Erro ao carregar os imóveis.');
      setIsLoading(false);
    }
  };

  const handleViewDetails = async (imovel) => {
    const translatedTitle = await translateText(imovel.title, language);
    const translatedDescription = await translateText(imovel.description, language);

    // Safely parse images_path
    let parsedImages = imovel.images_path;
    if (typeof parsedImages === 'string') {
      try {
        parsedImages = JSON.parse(parsedImages);
      } catch (e) {
        parsedImages = [];
      }
    }

    setSelectedImovel({
      ...imovel,
      title: translatedTitle,
      description: translatedDescription,
      images_path: parsedImages,
    });

    if (Array.isArray(parsedImages) && parsedImages.length > 0) {
      setSelectedImage(parsedImages[0]);
    } else {
      setSelectedImage(null);
    }

    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedImovel(null);
    setSelectedImage(null);
  };

  const handleFilterChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: name === 'category'
        ? (value === '' ? '' : Number(value))
        : (type === 'checkbox' ? checked : value),
      ...(name === 'district' ? { city: '' } : {}), // Reset city if district changes
    }));
  };

  // Update applyFilters to use district/city state instead of filters.district/city
  const applyFilters = (imoveis) => {
    const { category, premium, opportunity, keywords, business_type } = filters;
    return imoveis.filter((imovel) => {
      // Find the index of the imovel's category in any language
      let imovelCategoryIndex = -1;
      for (const lang of Object.keys(translations)) {
        const idx = translations[lang].categories.indexOf(imovel.category);
        if (idx !== -1) {
          imovelCategoryIndex = idx;
          break;
        }
      }
      const categoryMatches =
        category === '' || (imovelCategoryIndex !== -1 && Number(category) === imovelCategoryIndex);

      return (
        (district === '' || imovel.district === district) &&
        (city === '' || imovel.city === city) &&
        categoryMatches &&
        (!premium || imovel.premium) &&
        (!opportunity || imovel.opportunity) &&
        (keywords === '' || imovel.title.toLowerCase().includes(keywords.toLowerCase())) &&
        (business_type === '' || imovel.business_type === business_type)
      );
    });
  };

  const translateCategory = (category) => {
    // category can be a string (from imovel) or a number (from filter)
    if (typeof category === 'number') {
      return t.categories[category] || '';
    }
    // else, find index and translate
    for (const lang of Object.keys(translations)) {
      const idx = translations[lang].categories.indexOf(category);
      if (idx !== -1) return t.categories[idx];
    }
    return category;
  };

  const translateGarage = (garage) => {
    const index = translations.pt.garageOptions.indexOf(garage);
    return index !== -1 ? t.garageOptions[index] : garage;
  };

  const translateBusinessType = (business_type) => {
    return business_type === 'Comprar' ? t.buy : t.rent;
  };

  const filteredImoveis = applyFilters(imoveis);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredImoveis.length / itemsPerPage);
  const paginatedImoveis = filteredImoveis.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const renderPageButtons = () => {
    const pageButtons = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <Button
          key={i}
          className={classes.pageButton}
          onClick={() => handlePageChange(i)}
          variant={currentPage === i ? 'contained' : 'outlined'}
          color="primary"
        >
          {i}
        </Button>
      );
    }

    return pageButtons;
  };

  // Helper to get current image index
  const getCurrentImageIndex = () => {
    if (!selectedImovel || !Array.isArray(selectedImovel.images_path)) return -1;
    return selectedImovel.images_path.indexOf(selectedImage);
  };

  const handlePrevImage = () => {
    if (!selectedImovel || !Array.isArray(selectedImovel.images_path)) return;
    const idx = getCurrentImageIndex();
    if (idx > 0) setSelectedImage(selectedImovel.images_path[idx - 1]);
  };

  const handleNextImage = () => {
    if (!selectedImovel || !Array.isArray(selectedImovel.images_path)) return;
    const idx = getCurrentImageIndex();
    if (idx < selectedImovel.images_path.length - 1) setSelectedImage(selectedImovel.images_path[idx + 1]);
  };

  // Helper for enlarged image navigation
  const getEnlargedImageIndex = () => {
    if (!selectedImovel || !Array.isArray(selectedImovel.images_path) || !enlargedImage) return -1;
    return selectedImovel.images_path.indexOf(enlargedImage);
  };
  const handlePrevEnlargedImage = () => {
    const idx = getEnlargedImageIndex();
    if (idx > 0) setEnlargedImage(selectedImovel.images_path[idx - 1]);
  };
  const handleNextEnlargedImage = () => {
    const idx = getEnlargedImageIndex();
    if (idx < selectedImovel.images_path.length - 1) setEnlargedImage(selectedImovel.images_path[idx + 1]);
  };

  // Add this after all other useEffects
  useEffect(() => {
    if (
      selectedImovel &&
      Array.isArray(selectedImovel.images_path) &&
      selectedImovel.images_path.length > 0
    ) {
      setSelectedImage(selectedImovel.images_path[0]);
    }
  }, [selectedImovel]);

  return (
    <>
      <HeaderMenu />
      <RouteTracker />
      <div className={classes.root}>
        {/* All filters in the top right */}
        <div className={classes.filtersWrapper}>
          <div className={classes.filters}>
            {/* 
            <div className={classes.filterGroup}>
              <TextField
                name="keywords"
                label={t.keywords}
                value={filters.keywords}
                onChange={handleFilterChange}
                className={classes.filterItem}
                fullWidth
              />
            </div>
            */}
            {/* District filter */}
            <div className={classes.filterGroup}>
              <FormControl className={classes.filterItem} fullWidth>
                <InputLabel>{t.district}</InputLabel>
                <Select
                  name="district"
                  value={district}
                  onChange={e => setDistrict(e.target.value)}
                >
                  <MenuItem value=""><em>{t.all}</em></MenuItem>
                  {districts.map((d, idx) => (
                    <MenuItem key={idx} value={d}>{d}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* City filter (moved up) */}
            <div className={classes.filterGroup}>
              <FormControl className={classes.filterItem} fullWidth>
                <InputLabel>Cidade</InputLabel>
                <Select
                  name="city"
                  value={city}
                  onChange={e => {
                    setCity(e.target.value);
                    setFilters(prev => ({ ...prev, city: e.target.value }));
                  }}
                  disabled={!district}
                >
                  <MenuItem value=""><em>{t.all}</em></MenuItem>
                  {cities.map((c, idx) => (
                    <MenuItem key={idx} value={c}>{c}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Category filter */}
            <div className={classes.filterGroup}>
              <FormControl className={classes.filterItem} fullWidth>
                <InputLabel>{t.category}</InputLabel>
                <Select
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  <MenuItem value=""><em>{t.all}</em></MenuItem>
                  {t.categories.map((category, index) => (
                    <MenuItem key={index} value={index}>{category}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Business type filter */}
            <div className={classes.filterGroup}>
              <FormControl className={`${classes.filterItem} ${classes.businessTypeFilter}`} fullWidth>
                <InputLabel>{t.business_type}</InputLabel>
                <Select
                  name="business_type"
                  value={filters.business_type}
                  onChange={handleFilterChange}
                >
                  <MenuItem value=""><em>{t.all}</em></MenuItem>
                  <MenuItem value="Comprar">{t.buy}</MenuItem>
                  <MenuItem value="Arrendar">{t.rent}</MenuItem>
                </Select>
              </FormControl>
            </div>
            {/* Checkboxes */}
            <div className={classes.filterGroup + ' ' + classes.checkboxGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="premium"
                    checked={filters.premium}
                    onChange={handleFilterChange}
                    style={{ color: '#0000FF' }}
                  />
                }
                label={t.premium}
                className={classes.filterItem}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="opportunity"
                    checked={filters.opportunity}
                    onChange={handleFilterChange}
                    style={{ color: '#FF0000' }}
                  />
                }
                label={t.opportunity}
                className={classes.filterItem}
              />
            </div>
          </div>
        </div>
        {/* Cards */}
        {isLoading ? (
          <Typography variant="h6" className={classes.noData}>
            {t.loading}
          </Typography>
        ) : error ? (
          <Typography variant="h6" className={classes.noData}>
            {error}
          </Typography>
        ) : paginatedImoveis.length > 0 ? (
          <div className={classes.grid}>
            {paginatedImoveis.map((imovel) => (
              <Card key={imovel.id} className={classes.card} onClick={() => handleViewDetails(imovel)}>
                {imovel.premium && (
                  <Chip label={t.premium} className={`${classes.banner} ${classes.premiumBanner}`} />
                )}
                {imovel.opportunity && (
                  <Chip label={t.opportunity} className={`${classes.banner} ${classes.opportunityBanner}`} />
                )}
                <div className={classes.media}>
                  {imovel.prompt_image ? (
                    <img
                      src={`/Photos/Imoveis/${imovel.id}/${imovel.prompt_image}`}
                      alt={`${imovel.title} prompt`}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => { e.target.onerror = null; e.target.style.display = 'none'; e.target.parentNode.querySelector('.no-image-msg').style.display = 'flex'; }}
                    />
                  ) : null}
                  <div
                    className="no-image-msg"
                    style={{
                      display: imovel.prompt_image ? 'none' : 'flex',
                      width: '100%',
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#f0f0f0',
                      color: '#888',
                      fontWeight: 'bold',
                      position: imovel.prompt_image ? 'absolute' : 'static',
                      top: 0,
                      left: 0,
                    }}
                  >
                    {t.noImages}
                  </div>
                </div>
                <CardContent className={classes.content}>
                  <div>
                    <Typography variant="h6" component="h2">
                      {imovel.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.location}: {imovel.district}{imovel.city ? `, ${imovel.city}` : ''}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.category}: {translateCategory(imovel.category)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.price}: €{imovel.price.toLocaleString()}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.area}: {imovel.area} m²
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.rooms}: {imovel.rooms}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.bathrooms}: {imovel.bathrooms}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.business_type}: {translateBusinessType(imovel.business_type)}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <Typography variant="h6" className={classes.noData}>
            {t.noData}
          </Typography>
        )}
        {/* Pagination Controls */}
        <div className={classes.pagination}>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <FaAngleDoubleLeft />
          </IconButton>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <FaArrowLeft />
          </IconButton>
          {renderPageButtons()}
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <FaArrowRight />
          </IconButton>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <FaAngleDoubleRight />
          </IconButton>
        </div>
        {/* Modal Dialog for Showing Imovel Details */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle className={classes.dialogTitle}>
            {t.detailsTitle}
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            {selectedImovel ? (
              <div>
                {/* --- Property Details Section --- */}
                <div style={{
                  borderBottom: '1px solid #eee',
                  marginBottom: 16,
                  paddingBottom: 8
                }}>
                  <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                    {selectedImovel.title}
                  </Typography>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                    {/* Left: Main info */}
                    <div style={{ minWidth: 200, flex: '0 0 220px' }}>
                      <Typography variant="body1"><b>{t.category}:</b> {translateCategory(selectedImovel.category)}</Typography>
                      <Typography variant="body1"><b>{t.location}:</b> {selectedImovel.district}{selectedImovel.city ? `, ${selectedImovel.city}` : ''}</Typography>
                      <Typography variant="body1"><b>{t.price}:</b> €{selectedImovel.price.toLocaleString()}</Typography>
                      <Typography variant="body1"><b>{t.area}:</b> {selectedImovel.area} m²</Typography>
                      <Typography variant="body1"><b>{t.rooms}:</b> {selectedImovel.rooms}</Typography>
                      <Typography variant="body1"><b>{t.bathrooms}:</b> {selectedImovel.bathrooms}</Typography>
                      <Typography variant="body1"><b>{t.garageSlots}:</b> {translateGarage(selectedImovel.garage_slots)}</Typography>
                      <Typography variant="body1"><b>{t.business_type}:</b> {translateBusinessType(selectedImovel.business_type)}</Typography>
                    </div>
                    {/* Vertical divider */}
                    <div style={{
                      width: 1,
                      background: '#bbb',
                      margin: '0 16px',
                      minHeight: 60,
                      alignSelf: 'stretch'
                    }} />
                    {/* Right: Description */}
                    <div style={{ flex: 1, minWidth: 250 }}>
                      <Typography variant="body1" style={{ marginBottom: 4 }}>
                        <b>{t.description}:</b>
                      </Typography>
                      <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                        {selectedImovel.description}
                      </Typography>
                    </div>
                  </div>
                </div>
                {/* --- Images Carousel Section --- */}
                <div style={{
                  borderBottom: '1px solid #eee',
                  marginBottom: 16,
                  paddingBottom: 8
                }}>
                  <Typography variant="h6" style={{ marginBottom: 8 }}>{t.images}:</Typography>
                  {Array.isArray(selectedImovel.images_path) && selectedImovel.images_path.length > 0 ? (
                    <div>
                      {/* Full-size highlighted image always visible */}
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                        <IconButton onClick={handlePrevImage} disabled={getCurrentImageIndex() <= 0}>
                          <FaArrowLeft />
                        </IconButton>
                        {selectedImage && (
                          <img
                            src={`/Photos/Imoveis/${selectedImovel.id}/${selectedImage}`}
                            alt={selectedImovel.title}
                            className={classes.selectedImage}
                            style={{maxHeight: 1000, borderRadius: 8, boxShadow: '0 2px 8px #0001', cursor: 'pointer' }}
                            onClick={() => setEnlargedImage(selectedImage)}
                          />
                        )}
                        <IconButton onClick={handleNextImage} disabled={getCurrentImageIndex() >= selectedImovel.images_path.length - 1}>
                          <FaArrowRight />
                        </IconButton>
                      </div>
                      {/* Thumbnails row */}
                      <div className={classes.imageList} style={{ justifyContent: 'center' }}>
                        {selectedImovel.images_path.map((image, index) => (
                          <img
                            key={index}
                            src={`/Photos/Imoveis/${selectedImovel.id}/${image}`}
                            alt={`${selectedImovel.title} ${index + 1}`}
                            className={classes.imageItem}
                            onClick={() => setSelectedImage(image)}
                            style={{
                              border: selectedImage === image ? '2px solid #1976d2' : '1px solid #eee',
                              borderRadius: 4,
                              boxShadow: selectedImage === image ? '0 2px 8px #1976d233' : 'none',
                              cursor: 'pointer',
                              opacity: selectedImage === image ? 1 : 0.7,
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <Typography variant="body2" color="textSecondary">{t.noImages}</Typography>
                  )}
                </div>
                {/* --- User/Agent Information Section --- */}
                <div>
                  <Typography variant="h6" style={{ marginBottom: 8 }}>{t.agentInfo}:</Typography>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {selectedImovel.user_photo && (
                      <img
                        src={`/Photos/Users/${selectedImovel.user_photo}`}
                        alt={selectedImovel.user_name}
                        className={classes.userPhoto}
                        style={{ border: '2px solid #1976d2', marginRight: 16 }}
                      />
                    )}
                    <div>
                      <Typography variant="body1"><b>{t.name}:</b> {selectedImovel.user_name}</Typography>
                      <Typography variant="body1"><b>{t.email}:</b> {selectedImovel.user_email}</Typography>
                      <Typography variant="body1"><b>{t.contact}:</b> (+351) {selectedImovel.user_contact}</Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Typography variant="h6">{t.noData}</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              {t.close}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Enlarged Image Modal */}
        <Dialog
          open={!!enlargedImage}
          onClose={() => setEnlargedImage(null)}
          maxWidth="lg"
        >
          <DialogContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#222', position: 'relative', minHeight: 300 }}>
            {selectedImovel && enlargedImage && (
              <>
                <IconButton
                  onClick={handlePrevEnlargedImage}
                  disabled={getEnlargedImageIndex() <= 0}
                  style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#fff', background: 'rgba(0,0,0,0.3)' }}
                >
                  <FaArrowLeft />
                </IconButton>
                <img
                  src={`/Photos/Imoveis/${selectedImovel.id}/${enlargedImage}`}
                  alt="Enlarged"
                  style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: 8, background: '#fff', cursor: 'pointer' }}
                  onClick={() => setEnlargedImage(null)}
                />
                <IconButton
                  onClick={handleNextEnlargedImage}
                  disabled={getEnlargedImageIndex() >= selectedImovel.images_path.length - 1}
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: '#fff', background: 'rgba(0,0,0,0.3)' }}
                >
                  <FaArrowRight />
                </IconButton>
              </>
            )}
          </DialogContent>
        </Dialog>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  imoveis: state.imoveis,
});

export default connect(mapStateToProps)(withStyles(styles)(ImoveisPage));